/* jshint esversion: 6 */

export default (function(hash){

    let hours = hash.match(/([0-9]*)h/)
    if (hours) {
        hours = parseInt(hours[1]);
    } else {
        hours = 0;
    }

    let minutes = hash.match(/([0-9]*)m/)
    if (minutes) {
        minutes = parseInt(minutes[1]);
    } else {
        minutes = 0;
    }

    let seconds = hash.match(/([0-9]*)s/)
    if (seconds) {
        seconds = parseInt(seconds[1]);
    } else {
        seconds = 0;
    }

    return (hours * 60 * 60) + (minutes * 60) + seconds;
});


